import { NumberOfHitsComponent } from "./components/numberOfHits.component";
import { Base } from "./numberOfHits.base";

export const NumberOfHits = Object.assign(Base, {
    Component: NumberOfHitsComponent
});
